import { DespatchCrew } from "Models/despatch.crew";
import { DespatchTask } from "Models/despatch.task";
import { differenceInDays, startOfToday, startOfDay } from "date-fns";

export const checkIsEmptyTeam = (team: DespatchCrew): boolean => {
  return (
    !team?.memberLeader &&
    !team.members.length &&
    !team.fleets.length &&
    !team.storageBoxes?.length &&
    !team.tasks?.length
  );
};

export const checkIsEmptyTask = (task: DespatchTask): boolean => {
  const team = task.teams?.find((t) => {
    return differenceInDays(startOfToday(), startOfDay(new Date(t.createdTo!)));
  });

  return (
    !team?.memberLeader &&
    !team?.members?.length &&
    !team?.fleets?.length &&
    !task.storageBoxes?.length
  );
};
